import { render, staticRenderFns } from "./Cartaz.vue?vue&type=template&id=34371148"
import script from "./Cartaz.vue?vue&type=script&lang=js"
export * from "./Cartaz.vue?vue&type=script&lang=js"
import style0 from "./Cartaz.vue?vue&type=style&index=0&id=34371148&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports